module.exports = __webpack_public_path__ + "files/microsoft-certified.e771ec36.pdf";